import * as types from '../types'
import XLSX from 'xlsx'

const state = {
  excelUploadBusy: false,
  excelUploadProgress: 0,
  excelUploadStatus: null
}

const getters = {
  excelUploadStatus: (state) => {
    return state.excelUploadStatus
  },
  excelUploadProgress: (state) => {
    return state.excelUploadProgress
  },
  excelUploadBusy: (state) => {
    return state.excelUploadBusy
  }
}

const mutations = {
  [types.MUTATE_EXCEL_UPLOAD_STATUS]: (state, excelUploadStatusData) => {
    state.excelUploadStatus = excelUploadStatusData
  },
  [types.MUTATE_EXCEL_UPLOAD_PROGRESS]: (state, excelUploadProgressData) => {
    state.excelUploadProgress = excelUploadProgressData
  },
  [types.MUTATE_EXCEL_UPLOAD_BUSY]: (state, excelUploadBusyData) => {
    state.excelUploadBusy = excelUploadBusyData
  }
}

const actions = {
  [types.UPLOAD_EXCEL]: ({ commit, state, dispatch }, excelData) => {
    // First empty the status
    commit(types.MUTATE_EXCEL_UPLOAD_STATUS, null)
    commit(types.MUTATE_EXCEL_UPLOAD_BUSY, true)
    commit(types.MUTATE_EXCEL_UPLOAD_PROGRESS, 0)

    // First, delete all existing panels
    commit(types.MUTATE_PANELS, [])

    let reader = new FileReader()
    reader.onload = function(e) {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })
      let firstSheetName = workbook.SheetNames[0]
      let worksheet = workbook.Sheets[firstSheetName]
      let panels = []
      let panelCounter = 1 // @TODO Or do 'i - 3'?

      for (let i = 10; i <= 109; i++) {
        /*
        * A = RowID
        * B = Length
        * C = Width
        * D = Amount
        * E = L1
        * F = L2
        * G = B1
        * H = B2
        * I = Reference (max 30 chars)
        */
        let length = worksheet['B' + i]
        let width = worksheet['C' + i]
        let amount = worksheet['D' + i]
        let l1 = worksheet['E' + i]
        let l2 = worksheet['F' + i]
        let b1 = worksheet['G' + i]
        let b2 = worksheet['H' + i]
        let reference = worksheet['I' + i]
        if (length && width && amount) {
          let panel = {
            id: panelCounter,
            length: length.v,
            width: width.v,
            amount: amount.v,
            l1: !!l1,
            l2: !!l2,
            b1: !!b1,
            b2: !!b2,
            reference: reference ? reference.v.substring(0, 30) : null,
            valid: null
          }
          panels.push(panel)
          panelCounter++
        } else { break }
      }
      commit(types.MUTATE_PANELS, panels)
    }

    reader.onloadend = function() {
      commit(types.MUTATE_EXCEL_UPLOAD_BUSY, false)
      commit(types.MUTATE_EXCEL_UPLOAD_PROGRESS, 0)
    }

    reader.onprogress = function(e) {
      commit(types.MUTATE_EXCEL_UPLOAD_PROGRESS, Math.floor((e.loaded * 100) / e.total))
    }

    reader.onerror = function(e) {
      commit(types.MUTATE_EXCEL_UPLOAD_BUSY, false)
      commit(types.MUTATE_EXCEL_UPLOAD_STATUS, {
        'message': 'Dit bestand kan niet worden gelezen. Upload een Excel-bestand of download een <a href="/excel/Leeg_invoerformulier_configurator.xlsx" target="_blank" class="link">leeg formulier</a>',
        'errors': ['Dit bestand kan niet worden gelezen. Upload een Excel-bestand of download een <a href="/excel/Leeg_invoerformulier_configurator.xlsx" target="_blank" class="link">leeg formulier</a>'],
        'success': false
      })
    }

    // Make sure the filetype is xlsx
    if (excelData.name.split('.').pop().toLowerCase().substr(0, 3) === 'xls') {
      reader.readAsArrayBuffer(excelData)
    } else {
      commit(types.MUTATE_EXCEL_UPLOAD_BUSY, false)
      commit(types.MUTATE_EXCEL_UPLOAD_STATUS, {
        'message': 'Dit bestand kan niet worden gelezen. Upload een Excel-bestand of download een <a href="/excel/Leeg_invoerformulier_configurator.xlsx" target="_blank" class="link">leeg formulier</a>',
        'errors': ['Dit bestand kan niet worden gelezen. Upload een Excel-bestand of download een <a href="/excel/Leeg_invoerformulier_configurator.xlsx" target="_blank" class="link">leeg formulier</a>'],
        'success': false
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
